import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import useRunOnceWhenTruthy from "../../hooks/useRunOnceWhenTruthy";
import {deleteAppointment} from "../../api";
import {ADD_NOTIFICATION} from "../../store/action";
import {useConfirmDialog} from "../Dialog";
import ConfirmDialog from "../ConfirmDialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import DialogContent from "@material-ui/core/DialogContent";
import {Field, reduxForm} from "redux-form";
import DateAndTimePicker from "../reduxFormComponents/DateAndTimePicker";
import ChipsSelect from "../reduxFormComponents/ChipsSelect";
import TextInputLikeDropdown from "../reduxFormComponents/TextInputLikeDropdown";
import {TextInput} from "../reduxFormComponents/TextInput";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        title: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        field: {
            marginBottom: theme.spacing(4),
        },
        submitButton: {
            marginLeft: theme.spacing(2)
        },
        option: {
            paddingLeft: theme.spacing(1)
        }
    }
});

const EnterDetails = ({proceedToPayment, appointmentId, handleCloseAndDestroyForm, change, handleSubmit, activities: rawActivity, refetchData, isAdmin, customerOptions = [], activityId, dispatch, reset, editMode}) => {
    const {t} = useTranslation()
    const classes = useStyles();
    const activities = useMemo(() => {
        return rawActivity.map(({_id, price, duration, subProfessionId: {heName}}) => ({
            activityId: _id,
            heName,
            duration: duration,
            price: price,
        }))
    }, [rawActivity])
    useRunOnceWhenTruthy(() => {
        if (activityId) {
            const selectedActivity = activities.find(({heName, duration, price}) => `${heName}@${duration}@${price}` === activityId)
            change('activity', selectedActivity)
        }
    }, activityId && activities)
    // const {shortHash} = useParams()

    // useEffect(() => {
    //     if (!isAdmin) {
    //         const customer = JSON.parse(localStorage.getItem('customer'))
    //         if (customer) {
    //             const customerObj = customerOptions.find(({heName}) => customer.name === heName)
    //             if (customerObj) {
    //                 change('customer.phone', customerObj.phone)
    //                 change('customer.name', customerObj)
    //             }
    //         }
    //     }
    // }, [isAdmin, customerOptions, isOpen])


    const {DialogComp, handleClickOpen} = useConfirmDialog(ConfirmDialog)
    return <form onSubmit={handleSubmit}>
        <DialogTitle id="form-dialog-title" className={classes.title} disableTypography>
            <Typography variant="h6">{editMode ? t('edit_appointment') : t('create_appointment')}</Typography>
            {editMode && <IconButton aria-label="delete" onClick={() => {
                handleClickOpen().then(isApproved => {
                    if (isApproved) {
                        deleteAppointment({appointmentId}).then(() => {
                            dispatch({
                                type: ADD_NOTIFICATION,
                                payload: {
                                    type: 'success',
                                    text: t('appointment_deleted')
                                }
                            })
                            refetchData()
                            handleCloseAndDestroyForm()
                        })
                    }
                })
            }}>
                <DeleteIcon color={'primary'} vari/>
                {DialogComp}
            </IconButton>}
        </DialogTitle>
        <DialogContent dividers>
            <Field name="dateAndTime" className={classes.field} component={DateAndTimePicker}
                   label={t('dateAndTime')}/>
            <Field name="activity" className={classes.field} required component={ChipsSelect} label={t('activity')}
                   freeSolo={false} dropdown={true} disableClearable={true}
                   renderOption={({heName, duration, price}) =>
                       <span><span className={classes.option}>{heName}</span><span
                           className={classes.option}>{`${duration} ${t('min')}`}</span><span
                           className={classes.option}>{`$${price}`}</span></span>}
                   options={activities}/>
            {isAdmin && <Field name="customer.name" className={classes.field} required
                               component={ChipsSelect}
                               label={t('customerName')}
                               options={customerOptions}
                               customOnChange={(option) => isAdmin && option?.phone ? change('customer.phone', option?.phone) : null}/>}
            {!isAdmin && <Field name="customer.name" className={classes.field} required
                                component={TextInputLikeDropdown}
                                label={t('customerName')}/>}
            <Field name="customer.phone" required className={classes.field} component={TextInput}
                   label={t('customerPhone')}
                   type={'tel'}/>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => {
                reset();
                handleCloseAndDestroyForm()
            }} variant={'outlined'} color="primary">
                {t('cancel')}
            </Button>
            <Button variant={'contained'} color="primary" className={classes.submitButton} type={'submit'}>
                {editMode ? t('update') : proceedToPayment ? t('next') : t('create')}
            </Button>
        </DialogActions>
    </form>
}
export default reduxForm({
    form: 'bookingAppointmentWizard',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(EnterDetails);